import api from '@/shared/utils/apiConfig';
import type { NavWorkspaceEntry, NavWorkspacePreference } from '@/shared/layout/nav/workspace';

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

export interface NavWorkspaceWrite {
  activeId: string;
  workspaces: NavWorkspaceEntry[];
}

export const navWorkspaceAPI = {
  get: async (): Promise<NavWorkspacePreference> => {
    const response = await api.get<ApiEnvelope<NavWorkspacePreference>>('/me/nav-workspaces');
    return response.data.data;
  },

  put: async (payload: NavWorkspaceWrite): Promise<NavWorkspacePreference> => {
    const response = await api.put<ApiEnvelope<NavWorkspacePreference>>('/me/nav-workspaces', payload);
    return response.data.data;
  },
};
